export enum DataLayerSection {
  Overview = `overview`,
  Logs = `logs`,
  Webhooks = `webhooks`,
}

export const DataLayersSectionLabel: Record<DataLayerSection, string> = {
  [DataLayerSection.Overview]: `Data Sources`,
  [DataLayerSection.Logs]: `Logs`,
  [DataLayerSection.Webhooks]: `Webhooks`,
}

export const INVALID_SOURCES_LIST = [
  `gatsby-source-filesystem`,
  `gatsby-source-git`,
]
